<div *ngIf="getUserName()">
  <p-menu #menu [model]="items" [popup]="true"></p-menu>
  <button pButton type="button" (click)="menu.toggle($event)" icon="albis-icons-menu-dots" iconPos="right"
          label="{{getUserName()}}" class="white-space-nowrap"></button>
</div>
